import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import * as constants from "./constants";
import HttpClient from "../http/index";
import { isJSON } from "@/utils/lodash";
import { sendMapEvent } from "@/utils/analytics";
import { getLang } from "@/api/utils/apiHelper";
import { toString } from "lodash";

var faceClientErrorEvent = function faceClientErrorEvent(key, result) {
  try {
    if (result.data && typeof result.data === "string" && result.data.includes("false")) {
      if (isJSON(result.data)) {
        var error = JSON.parse(result.data);
        sendMapEvent("face_" + key, {
          error_code: error.code ? toString(error.code) : "1001",
          error_message: error.message ? error.message : "null"
        });
      } else {
        sendMapEvent("face_" + key, {
          error_code: "1002",
          error_message: result.data
        });
      }
    } else {
      sendMapEvent("face_" + key, {
        error_code: "",
        error_message: toString(result)
      });
    }
  } catch (error) {}
};

var FaceIdeaClient =
/*#__PURE__*/
function () {
  function FaceIdeaClient() {
    _classCallCheck(this, FaceIdeaClient);
  }

  _createClass(FaceIdeaClient, [{
    key: "CommonRequestFactory",
    value: function CommonRequestFactory() {
      var req = {};
      req.headers = {};
      var deviceInfo = window.device;
      req.headers["User-Agent"] = constants.UA;
      req.headers["Content-Type"] = "application/json";
      req.data = {};
      req.data.device_id = deviceInfo.deviceId; // req.data.device_id = getUUid();

      return req;
    }
    /**
     * 明星图库信息
     */

  }, {
    key: "get_celebrities",
    value: function get_celebrities(image) {
      var _this = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  req = _this.CommonRequestFactory();
                  req.data.image = image;
                  req.serializer = "json";
                  _context.next = 6;
                  return HttpClient.post(constants.BASE_URL + constants.FACE_CELEBRITE_PATH, req);

                case 6:
                  res = _context.sent;

                  // faceClientErrorEvent("get_celebrities", res); //打点
                  if (res.status === 200 && res.data) {
                    resolve(JSON.parse(res.data));
                  }

                  resolve(res);
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](0);
                  // clientError("get_celebrities", error);
                  reject(_context.t0);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 11]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
    /**
     * 明星图库照片
     */

  }, {
    key: "get_align_image",
    value: function get_align_image(image) {
      var _this2 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  req = _this2.CommonRequestFactory();
                  req.data.images = [image];
                  req.serializer = "json";
                  _context2.next = 6;
                  return HttpClient.post(constants.BASE_URL + constants.FACE_ALIGN_PATH, req);

                case 6:
                  res = _context2.sent;

                  // faceClientErrorEvent("get_align_image", res); //打点
                  if (res && res.data && res.status === 200) {
                    resolve(JSON.parse(res.data));
                  }

                  _context2.next = 13;
                  break;

                case 10:
                  _context2.prev = 10;
                  _context2.t0 = _context2["catch"](0);
                  // clientError("get_align_image", error);
                  reject(_context2.t0);

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 10]]);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "language",
    get: function get() {
      return getLang();
    }
  }]);

  return FaceIdeaClient;
}();

export default new FaceIdeaClient();